import { format } from 'date-fns';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util/capitalizeFirstLetter';
import formatCloseRelative from '../../Util/formatCloseRelative';
import { type StyrOchStällItemProperties } from '../Sources/StyrOchStällSource';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function StyrOchStall(properties: StyrOchStällItemProperties): JSX.Element {
    return (
        <PopupTemplateWrapper iconId="bike-station" title="Lånecykelstation">
            <div className="">
                <h3>Styr & Ställ {properties.name}</h3>
                {properties.availableBikes} lediga cyklar
                <br />
                <a className="info-link" href="https://styrochstall.se" target="_blank" rel="noreferrer">
                    Om Styr & Ställ
                </a>
                <dl className="popup-details">
                    <dt>Uppdaterad:</dt>
                    <dd title={format(properties.lastUpdateDate, 'Pp')}>
                        <TimeElement date={properties.lastUpdateDate}>
                            {capitalizeFirstLetter(formatCloseRelative(properties.lastUpdateDate))}
                        </TimeElement>
                    </dd>
                </dl>
            </div>
        </PopupTemplateWrapper>
    );
}
